import ads from '@assets/images/ads-logo.png';
import justice from '@assets/images/justice-logo.jpg';
import sperasoft from '@assets/images/sperasoft-logo.jpeg';

export enum ExperienceItemIds {
  non_exist = 'non_exist',
  justice = 'justice_position',
  ads = 'ads_aggregator_position',
  sperasoft = 'sperasoft_position',
}

export enum ELinkIcons {
  linkedin = 'linkedin',
  telegram = 'telegram',
  github = 'github',
  email = 'email',
}

export interface StackItem {
  name: string;
  length: number;
}

export interface ContactItem {
  name: string;
  link: string;
  icon: ELinkIcons;
}

export interface IDiploma {
  degree: string;
  field: string;
  program: string;
  period: string;
  grade: string;
  description: string;
}

export interface ExperienceDescription {
  mainDesc: string[];
  listDesc: string[];
}

export interface IEducationInfo {
  title: string;
  location: string;
  link: string;
  description: string;

  diplomas: IDiploma[];
}

export interface ExperienceInfo {
  id: ExperienceItemIds;
  avatar: string;
  company: string;
  jobTitle: string;
  employmentType: 'Full-time' | 'Part-time' | 'Freelance';
  location: string;
  locationType: 'On-site' | 'Hybrid' | 'Remote';
  industry: string;
  description: ExperienceDescription;
  startDate: Date;
  endDate: Date | 'now';
  stack: StackItem[];
}

export interface IMainInfo {
  PORTFOLIO_NAME: string;
  JOB_TITLE: string;
  SHORT_DESCRIPTION: string;

  EDUCATION_INFO: IEducationInfo;

  EXPERIENCE_INFO: ExperienceInfo[];

  ABOUT_INFO: string[];
  SKILL_INFO: string[];

  contact: ContactItem[];
}

export const mainInfo: IMainInfo = {
  PORTFOLIO_NAME: 'Vladimir Goncharov',
  JOB_TITLE: 'Full Stack Web Developer',
  SHORT_DESCRIPTION:
    'I am a Full Stack Web Developer working with JavaScript, TypeScript and Python technologies. ' +
    'I strongly believe that digitalization may help many people to overcome difficulties and problems. ' +
    'So my passion is to build beautiful, stable, and helpful applications. ',

  EDUCATION_INFO: {
    title: 'Southern Federal University',
    location: 'Rostov-on-don, Russia',
    link: 'https://sfedu.ru/',
    description:
      'Southern Federal University (SFedU), along with Siberian Federal University, ' +
      'was founded as the pilot project of new federal universities establishments. ' +
      'Currently, there are only ten federal universities in Russia. SFedU traces its history back to 1915.',

    diplomas: [
      {
        degree: "Master's degree",
        field: 'Computer science',
        program: 'Information systems and web-application development',
        period: '2021-2023',
        grade: '5.0 / 5.0',
        description:
          'At this degree, professional knowledge in Web and Software Engineering was obtained',
      },
      {
        degree: "Bachelor's degree",
        field: 'Computer science',
        program: 'Cyber security',
        period: '2017-2021',
        grade: '4.8 / 5.0',
        description:
          'At this degree, basic knowledge in Computer Science and Software Engineering studies was obtained',
      },
    ],
  },

  EXPERIENCE_INFO: [
    {
      id: ExperienceItemIds.sperasoft,
      avatar: sperasoft,
      company: 'Sperasoft',
      jobTitle: 'Full Stack Web Developer',
      employmentType: 'Full-time',
      location: 'Yerevan, Armenia',
      locationType: 'Remote',
      industry: 'Software Engineering, Computer Science',
      description: {
        mainDesc: [
          'At the time working for Sperasoft, I gained opportunity to work with new technologies as Python and Django.' +
            'Working here, I obtained experience with SSR wed-application and deepened my knowledge in Web Development.',
          'Tasks:',
        ],
        listDesc: [
          'Support old application written on JQuery (JavaScript) and Django (Python)',
          'Added new functionality to the application',
        ],
      },
      startDate: new Date('9/15/2023'),
      endDate: 'now',
      stack: [
        {
          name: 'JavaScript',
          length: 0.1,
        },
        {
          name: 'Python',
          length: 0.1,
        },
        {
          name: 'HTML',
          length: 0.1,
        },
        {
          name: 'CSS',
          length: 0.1,
        },
        {
          name: 'JQuery',
          length: 0.1,
        },
        {
          name: 'Perforce',
          length: 0.1,
        },
        {
          name: 'Bootstrap',
          length: 0.1,
        },
        {
          name: 'Django',
          length: 0.1,
        },
        {
          name: 'MySQL',
          length: 0.1,
        },
      ],
    },
    {
      id: ExperienceItemIds.justice,
      avatar: justice,
      company: 'Justice IT',
      jobTitle: 'Full Stack Web Developer',
      employmentType: 'Full-time',
      location: 'Taganrog, Rostov Oblast, Russia',
      locationType: 'On-site',
      industry: 'Software Engineering, Computer Science',
      description: {
        mainDesc: [
          'While working in Justice IT, I participated in several commercial projects as\n' +
            'application for staff management and collecting statistics about employees,\n' +
            'and application for warehouse accounting of goods of companies, etc.\n' +
            'I gained a lot of experience working in different teams with distinct\n' +
            'technologies.',
          'Tasks:',
        ],
        listDesc: [
          'Created user interface (layout and logic of client application) including\n' +
            'different forms for user to fill and pages to display information with\n' +
            'interactive parts, using different UI-libraries such as Material UI, MDB,\n' +
            'Bootstrap, styling methods such as SASS, SCSS, Styled Components and\n' +
            'CSS and different global state managers as Redux, Redux Toolkit, Context,\n' +
            'MobX.',
          'Worked with different libraries to draw Tables (MUI Tables, React Bootstrap\n' +
            'Table, etc) and Graphs (ECharts, Chart.js, React Charts, etc).',
          'On the backend part, built REST API using Nest.js framework, PostgresQL as\n' +
            'DBMS, Sequelize as ORM, Redis as a cache manager, Nodemailer to send\n' +
            'mail.',
          'Built user authorization-registration flow on backend side, using technique\n' +
            'to form tokens as JWT, passing tokens through the cookies of request,\n' +
            'wrote guards to process checks on access and refresh tokens.',
          'Created APIs to cover CRUD operations to store data from client to DB, get\n' +
            'from DB and send on client, update and delete data saved in DB.',
          'Setting Sequelize migrator in project and creating migrations to fill\n' +
            'database with basic information and migrations to change database\n' +
            'structure.',
          'Covered project with unit and e2e tests using Jest.',
          'Bug fix.',
        ],
      },
      startDate: new Date('1/10/2022'),
      endDate: new Date('7/21/2023'),
      stack: [
        {
          name: 'JavaScript',
          length: 1.6,
        },
        {
          name: 'TypeScript',
          length: 1.6,
        },
        {
          name: 'HTML',
          length: 1.6,
        },
        {
          name: 'CSS',
          length: 1.6,
        },
        {
          name: 'GIT',
          length: 1.6,
        },
        {
          name: 'React',
          length: 1.6,
        },
        {
          name: 'Redux Toolkit',
          length: 1.6,
        },
        {
          name: 'Thunks',
          length: 1.6,
        },
        {
          name: 'Formik',
          length: 1.6,
        },
        {
          name: 'Yup',
          length: 1.6,
        },
        {
          name: 'MUI',
          length: 1.6,
        },
        {
          name: 'Styled Components',
          length: 1,
        },
        {
          name: 'Sass/Scss',
          length: 0.6,
        },
        {
          name: 'Axios',
          length: 1.6,
        },
        {
          name: 'Express',
          length: 0.4,
        },
        {
          name: 'Nest',
          length: 0.8,
        },
        {
          name: 'Redis',
          length: 0.8,
        },
        {
          name: 'PostgresQL',
          length: 0.8,
        },
        {
          name: 'Sequelize',
          length: 0.8,
        },
        {
          name: 'Docker',
          length: 0.4,
        },
        {
          name: 'i18n',
          length: 0.8,
        },
        {
          name: 'Nodemailer',
          length: 0.8,
        },
        {
          name: 'Jest',
          length: 0.8,
        },
      ],
    },
    {
      id: ExperienceItemIds.ads,
      avatar: ads,
      company: 'Ads aggregator platform',
      jobTitle: 'Full Stack Web Developer',
      employmentType: 'Full-time',
      location: 'Taganrog, Rostov Oblast, Russia',
      locationType: 'Remote',
      industry: 'Software Engineering, Computer Science',
      description: {
        mainDesc: [
          'While working in Ads aggregator platform, I obtained experience to read\n' +
            'legacy code and support such projects, experience of professional\n' +
            'communication and experience of working in real commercial project.',
          'Tasks:',
        ],
        listDesc: [
          'Support old application written on JQuery adding new functionality to it\n' +
            'and fixing appearing bugs.',
          'Get known with backend development writing some APIs Express.JS\n' +
            'application and working with CRUD operations. Also worked with sql-\n' +
            'requests using mysql2 ORM and DBMS MariaD.',
          'Rebuilt client application on React.js using MDB UI-library, recreating\n' +
            'functionality of old application in new design with modern technologies.',
          'Built client registration-authorization system with access differentiation to\n' +
            'hide or display some parts of interface according to role of user.',
          'Built pages to display statistics and information about advertisement\n' +
            'drawing tables (AG Grid, MDB tables) and graphs (AG Grid, MDB graph).',
          'Built system to interact with data and to display personal statistics\n' +
            'creating system of filters, metrics and attributes adding some forms for\n' +
            'user to intuitively work with data.',
          'Created library of components in storybook.',
          'Covered functionality with unit-tests and fixed bugs.',
        ],
      },
      startDate: new Date('11/8/2020'),
      endDate: new Date('10/29/2021'),
      stack: [
        {
          name: 'TypeScript',
          length: 1,
        },
        {
          name: 'JavaScript',
          length: 1,
        },
        {
          name: 'HTML',
          length: 1,
        },
        {
          name: 'CSS',
          length: 1,
        },
        {
          name: 'GIT',
          length: 1,
        },
        {
          name: 'React',
          length: 1,
        },
        {
          name: 'Redux',
          length: 1,
        },
        {
          name: 'Redux-saga',
          length: 1,
        },
        {
          name: 'Storybook',
          length: 1,
        },
        {
          name: 'Axios',
          length: 1,
        },
        {
          name: 'Formik',
          length: 1,
        },
        {
          name: 'Yup',
          length: 1,
        },
        {
          name: 'MDB',
          length: 1,
        },
        {
          name: 'Sass/Scss',
          length: 1,
        },
        {
          name: 'Express',
          length: 0.4,
        },
        {
          name: 'MySQL',
          length: 0.5,
        },
        {
          name: 'Jest',
          length: 0.7,
        },
        {
          name: 'JQuery',
          length: 0.3,
        },
        {
          name: 'Redis',
          length: 0.4,
        },
      ],
    },
  ],

  ABOUT_INFO: [
    '🤣 Perhaps, I am the first one who wants to raise this eternal question... ' +
      'Should we consider a programmer as hardware? So, while you are processing this idea, ' +
      'I want to present my "characteristics".',
    '👨‍💻 As a kid, I saw the legendary movie "Around the World in 80 Days" and since then, ' +
      'I dreamed of becoming an inventor. After series of random events, ' +
      'I entered the university on IT department and started my path as software "inventor". ' +
      'I like my specialty because we help people simplify their lives building beautiful and helpful software.',
    "🧐 I was studying since 2017 in the university getting my bachelor's degree " +
      'and basics of computer science and software engineering. ' +
      'Since 2020, I have been working as a web developer writing Frontend and Backend on JavaScript (TypeScript) ' +
      "using different Node.js technologies. And later in 2021, I started my master's degree, to confirm my abilities.",
    '🤖 I am a full stack web developer with main experience and expertise in frameworks ' +
      'as React on Frontend with different UI-libraries, and Express or Nest on Backend with DBMS like MongoDB, MySQL, ' +
      'and PostgreSQL.',
    '🎨 So my passion is to build beautiful, stable, and helpful application with a bunch of cool features. ' +
      'I strongly believe that digitalization may help a lot of people to overcome difficulties and problems.',
  ],
  SKILL_INFO: [
    '— Proficient in HTML5, CSS3, JavaScript, TypeScript, Node.js',
    '— Experienced (frontend) in React.js, Redux, Redux Toolkit, Material\n' +
      'UI, Bootstrap, MDB, SASS/SCSS, Styled components, etc',
    '— Experienced (backend) in Express.js, Nest.js, PostgersQL, MySQL,\n' +
      'Sequelize, mysql2, Redis, Nodemailer, Docker, etc',
    '— Skilled in creating modern and efficient interfaces for web\n' +
      'applications, creating layouts and logic for clients',
    '— Skilled in creating web applications, writing REST APIs, creating\n' +
      'database structure, processing data on server and creating\n' +
      'CRUD operations',
    '— Skilled in adaptability, teamwork, communication, problem-solving and creativity',
  ],

  contact: [
    {
      name: 'LinkedIn Link',
      icon: ELinkIcons.linkedin,
      link: 'https://www.linkedin.com/in/vgoncharoff',
    },
    {
      name: 'Github Link',
      icon: ELinkIcons.github,
      link: 'https://github.com/LetoDArt',
    },
    {
      name: 'Telegram Link',
      icon: ELinkIcons.telegram,
      link: 'https://t.me/LetoDArt',
    },
    {
      name: 'Email Link',
      icon: ELinkIcons.email,
      link: 'mailto:letodart2077@gmail.com',
    },
  ],
};
export const ExperienceDefault: ExperienceInfo = {
  id: ExperienceItemIds.ads,
  avatar: ads,
  company: 'Ads aggregator platform',
  jobTitle: 'Full Stack Web Developer',
  employmentType: 'Full-time',
  location: 'Taganrog, Rostov Oblast, Russia',
  locationType: 'Remote',
  industry: 'Software Engineering, Computer Science',
  description: {
    mainDesc: [
      'While working in Ads aggregator platform, I obtained experience to read\n' +
        'legacy code and support such projects, experience of professional\n' +
        'communication and experience of working in real commercial project.',
      'Tech stack: React, Redux, Redux-saga, Storybook, Axios, Formik, Yup, MDB,\n' +
        'Express,js, MariaDB, mysql2, Redis, TypeScript, Jest, JQuery.',
      'Tasks:',
    ],
    listDesc: [
      'Support old application written on JQuery adding new functionality to it\n' +
        'and fixing appearing bugs.',
      'Get known with backend development writing some APIs Express.JS\n' +
        'application and working with CRUD operations. Also worked with sql-\n' +
        'requests using mysql2 ORM and DBMS MariaD.',
      'Rebuilt client application on React.js using MDB UI-library, recreating\n' +
        'functionality of old application in new design with modern technologies.',
      'Built client registration-authorization system with access differentiation to\n' +
        'hide or display some parts of interface according to role of user.',
      'Built pages to display statistics and information about advertisement\n' +
        'drawing tables (AG Grid, MDB tables) and graphs (AG Grid, MDB graph).',
      'Built system to interact with data and to display personal statistics\n' +
        'creating system of filters, metrics and attributes adding some forms for\n' +
        'user to intuitively work with data.',
      'Created library of components in storybook.',
      'Covered functionality with unit-tests and fixed bugs.',
    ],
  },
  startDate: new Date('11/8/2020'),
  endDate: new Date('10/29/2021'),
  stack: [],
};
